/* eslint-disable max-len */
export default {
  title: '关于我们',
  subtitle1: '赋能匠心设计，纵横创新技术，',
  subtitle2: '让用户感受无限快乐',
  description:
    '飞狼投资方 Fenrir Inc. 公司以设计和技术的完美结合而闻名于日本。\n总公司设立于大阪，旗下四家分公司，分别位于东京、京都、名古屋和岛根。另外分别在美国硅谷以及中国境内的上海、成都和大连三地各设有子公司。\n我们旨在紧密各方力量，联手打造绝对优势的IT服务团队。',
  info: {
    addressTitle: '办公地址',
    addressBtnText: '查看地图',
    postcodeTitle: '邮编',
    phoneNumberTitle: '电话',
    creationDateTitle: '成立日期',
  },
  list: [
    {
      id: 'sh',
      title: '上海',
      name: '飞狼数码（上海）有限公司',
      nameEN: 'Fenrir Shanghai Inc.',
      manager: {
        title: '总经理',
        name: '王 赫威',
      },
      description: [
        '在数字化飞速发展的中国市场，各个企业为了扩大事业规模，需要密切关注国内的新兴服务与技术，并尽快建立或完善能够与之对应的运营体制。',
        '为了帮助客户企业应对在中国市场开展业务时所面临的挑战和需求，让客户满意，我们将运用国内最前沿的移动技术，持续不断地支持客户企业的数字化发展。',
      ],
      address: {
        postcode: '200235',
        text: '上海市徐汇区南宁路970号徐汇万科B座20楼',
        poiid: 'B0FFHWL1B8',
        // location: [121.464391, 31.21858],
      },
      phoneNumber: '021-33639028',
      creationDate: '2021年4月30日',
    },
    {
      id: 'cd',
      title: '成都',
      name: '成都市飞狼科技有限公司',
      nameEN: 'Fenrir Chengdu Inc.',
      manager: {
        title: '总经理',
        name: '赵 岗',
      },
      description: [
        '从全面的用户视角，为客户提供最适合的解决方案，与客户一起致力于创造新的价值，让客户以及客户的客户得到更大的满足。',
        '坚持以人为本，关注员工的可能性，尊重员工的个人价值，不断为员工提供提升自我、超越自我的机会，追求为员工以及员工的家庭创造幸福与快乐。',
      ],
      address: {
        postcode: '610000',
        text: '四川省成都市高新区天府软件园D6栋15层',
        poiid: 'B001C8TY3I',
        // location: [104.067615, 30.551924],
      },
      phoneNumber: '028-85177409',
      creationDate: '2013年10月21日',
    },
    {
      id: 'dl',
      title: '大连',
      name: '大连飞狼科技有限公司',
      nameEN: 'Fenrir Dalian Inc.',
      manager: {
        title: '总经理',
        name: '梁 日棚',
      },
      description: [
        '大连飞狼科技秉承为客户带来满足，创造价值的理念，站在客户立场，用心体会客户需求，为客户提供高品质软件开发服务和IT解决方案。',
        '在经营管理上，力戒华而不实，最大程度发挥个人创造力和集体优势，实现员工和公司共同成长的目标。在客户合作上，以公正交易为基础，和客户构筑同存互利的合作关系，成为深受社会信赖的企业公民。',
      ],
      address: {
        postcode: '116085',
        text: '辽宁省大连市高新园区火炬路3号纳米大厦9楼',
        poiid: 'B019B0C1WK',
        // location: [121.526098, 38.859573],
      },
      phoneNumber: '0411-83731889',
      creationDate: '2014年12月12日',
    },
  ],
  qualification: {
    title: '企业资质认证',
    description: '飞狼以技术创新为根基，以专业服务连接企业发展的每一步。\n高新技术企业、技术先进型服务企业及专精特新中小企业认定，见证我们在研发创新与专业化道路上的持续积累；IFS 大中华地区正式授权总代理及云深处科技合作伙伴授权，进一步拓展了我们的技术与服务版图。\n从自主研发到生态协作，从业务洞察到方案落地，我们将每一份认可转化为交付的责任，以扎实的技术、严谨的品质与开放的合作，回应客户的长期信赖，支持企业探索数字化发展的更多可能。',
    images: [
      { img: 'about/ifs_zh.png', label: 'IFS 大中华地区正式授权总代理' },
      { img: 'about/robot.png', label: '云深处科技合作伙伴授权书' },
      { img: 'about/technology_enterprise.png', label: '高新技术企业证书' },
      { img: 'about/advanced_enterprise.png', label: '技术先进型服务企业' },
      { img: 'about/specialize.png', label: '专精特新中小企业' },
    ],
  },
};
